import { Controller } from "@hotwired/stimulus"
import { computePosition, flip, shift, autoUpdate } from "@floating-ui/dom"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import * as Log from "web-ui/log"

// Connects to data-controller="popover"
export default class extends Controller {
  static targets = ["container", "button", "popover"]

  connect() {
    this.debug("Connect")
  }

  disconnect() {
    this.debug("Disconnect")
  }

  isVisible() {
    return this.containerTarget.classList.contains("visible")
  }

  closePopover() {
    morphdomIgnore(this.element, false)
    this.containerTarget.classList.remove("visible", "top", "bottom")
    this.buttonTarget.removeAttribute("aria-expanded")

    if (this.disableAutoUpdate) {
      this.disableAutoUpdate()
    }
  }

  open() {
    morphdomIgnore(this.element, true)
    this.containerTarget.classList.add("visible")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.popoverTarget.scrollTop = 0
    this.popoverTarget.style.left = null

    this.disableAutoUpdate = autoUpdate(
      this.buttonTarget,
      this.popoverTarget,
      this.updatePosition
    );
  }

  updatePosition = () => {
    computePosition(this.buttonTarget, this.popoverTarget, {
      placement: "top",
      middleware: [shift(), flip({ padding: 16 })],
    }).then(({ placement, middlewareData: { shift } }) => {
      if (placement === "top") {
        this.containerTarget.classList.add("top")
        this.containerTarget.classList.remove("bottom")
      } else {
        this.containerTarget.classList.add("bottom")
        this.containerTarget.classList.remove("top")
      }

      if (shift.x > 0 && !this.popoverTarget.style.left) {
        this.popoverTarget.style.left = `${shift.x}px`
      }
    })
  }

  close(event) {
    if (!this.isVisible()) {
      return
    }

    if (event) {
      if (event.key === "Escape") {
        this.closePopover()
      }

      if (this.element.contains(event.target)) {
        return
      }
    }

    this.closePopover()
  }

  toggle() {
    this.isVisible() ? this.close() : this.open()
  }

  debug(message, data) {
    Log.debug("Popover - " + message, data)
  }
}
